/**
 * @fileoverview Agent definition for continuity-extractor-v2.
 *
 * Extracts story-level continuity facts (deadlines, counts, locations,
 * in-world dates, promises, world rules, ongoing conditions) from a chapter,
 * and proposes resolutions for previously active facts.
 *
 * @category narrative.story.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'continuity-extractor-v2',
  kind: 'primitive',
  name: 'Continuity Extractor',
  description:
    'Extracts binding continuity facts (deadlines, counts, locations, in-world dates, ' +
    'promises, world rules, conditions) from a chapter and proposes resolutions for ' +
    'previously active facts.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-05',
    taxonomyPath: 'narrative.story.analysis',
    usedBy: ['use-continuity-extractor-v2.ts'],
    usedInComposites: [],
    relatedAgents: ['plot-snapshotter-v2', 'next-chapter-suggester-v2'],
  },
};
